module.exports = __webpack_public_path__ + "static/img/decidoc-06.33e3599.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/decidoc-06.png
// module id = 79
// module chunks = 0